import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ct-grid',
  templateUrl: './ct-grid.component.html',
  styleUrls: ['./ct-grid.component.css']
})
export class CtGridComponent implements OnInit {

  title = "Correspondance Tracking List";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/correspondance-tracking/ct-grid/ct-grid.component.ts